import React from "react";

// Sin tildes ni mayúsculas: "informatica" encuentra "Informática".
const normalizar = (texto) =>
  String(texto ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

// ¿Algún dato del registro contiene lo que se buscó? Con varias palabras, deben estar todas.
export function coincideBusqueda(busqueda, datos) {
  const texto = normalizar(datos.filter((d) => d !== null && d !== undefined).join(" "));
  return normalizar(busqueda)
    .split(/\s+/)
    .filter(Boolean)
    .every((palabra) => texto.includes(palabra));
}

// Cuadro de búsqueda de los catálogos, con el conteo de lo encontrado mientras hay algo escrito.
function BuscadorCatalogo({ valor, onCambiar, placeholder = "Buscar…", mostrados, total }) {
  const buscando = valor.trim() !== "";
  return (
    <div style={estilos.contenedor}>
      <div style={estilos.caja}>
        <span aria-hidden="true">🔍</span>
        <input
          type="search"
          value={valor}
          onChange={(e) => onCambiar(e.target.value)}
          placeholder={placeholder}
          aria-label={placeholder}
          style={estilos.input}
        />
      </div>
      {buscando && (
        <p style={{ ...estilos.resultado, ...(mostrados === 0 ? estilos.sinResultado : {}) }}>
          {mostrados === 0 ? "Ningún registro coincide con la búsqueda." : `Mostrando ${mostrados} de ${total}`}
        </p>
      )}
    </div>
  );
}

const estilos = {
  contenedor: { marginBottom: "0.8rem" },
  caja: {
    display: "flex",
    alignItems: "center",
    gap: "0.45rem",
    border: "1px solid #d3d9df",
    borderRadius: 8,
    padding: "0 0.65rem",
    background: "#fff",
  },
  input: {
    flex: 1,
    minWidth: 0,
    border: "none",
    outline: "none",
    padding: "0.5rem 0",
    fontFamily: "inherit",
    fontSize: "0.88rem",
    background: "transparent",
  },
  resultado: { margin: "0.35rem 0 0", fontSize: "0.76rem", color: "#5b6472" },
  sinResultado: { color: "#a3402f", fontWeight: 600 },
};

export default BuscadorCatalogo;
